(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/dialogs/shared-dialogs.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/dialogs/shared-dialogs.js');

'use strict';

const _svs$accountservicesR = svs.accountservicesReact.deposit.helpers.sharedHelpers,
  swedbankpayErrorTranslate = _svs$accountservicesR.swedbankpayErrorTranslate,
  getErrorCode = _svs$accountservicesR.getErrorCode;
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const trackFailure = svs.accountservicesReact.deposit.tracking.sharedTracking.trackFailure;
const logger = svs.accountservicesReact.deposit.depositShared.logger;

const handleSwishSsnError = () => {
  const swishDialogTitle = 'Insättning misslyckades';
  if (svs.core.detect.formfactor.mobile()) {
    return {
      swishDialogTitle,
      swishMsg: 'Swish på denna enhet är inte kopplat till samma personnummer som ditt konto på Svenska Spel. Välj en annan insättningsmetod'
    };
  }
  return {
    swishDialogTitle,
    swishMsg: 'Angivet mobilnummer är inte kopplat till ditt Swish-konto. Ange korrekt mobilnummer eller välj en annan insättningsmetod'
  };
};
const getDepositErrorMessage = (error, transactionData, maxLimitLeft) => {
  var _transactionData$paym;
  let isShowKycError = false;
  let dialogTitle = 'Fel vid insättning';
  let dialogText = 'Försök igen senare eller kontakta Svenska Spels Kundservice.';
  let isShowChangeDeposit = false;
  const paymentTypeLower = (transactionData === null || transactionData === void 0 || (_transactionData$paym = transactionData.paymentType) === null || _transactionData$paym === void 0 ? void 0 : _transactionData$paym.toLowerCase()) || '';
  if (error) {
    let errorCode = getErrorCode(error);
    trackFailure(paymentTypeLower, errorCode);

    if (paymentTypeLower === paymentTypes.BANKCARD || paymentTypeLower === paymentTypes.APPLEPAY) {
      errorCode = swedbankpayErrorTranslate(errorCode);
    }
    const depositLimitsCommonError = ' Kontrollera dina insättningsgränser och försök igen. Har du nyligen gjort en överföring som blev misslyckad/avbruten, avvakta 30 minuter och försök igen.';
    switch (errorCode) {
      case 99:
        logger.info('Error 99: Bad Message Format', error);
      case 1: 
      case 7:
        isShowChangeDeposit = true; 
        dialogText = 'Insättning avbruten. Försök igen eller kontakta Svenska Spels Kundservice för vidare hjälp.';
        break;
      case 297:
        if (paymentTypeLower === paymentTypes.SWISH) {
          dialogText = 'Du har redan en pågående insättning med Swish. Öppna din Swish-app och signera eller avbryt denna och försök sedan igen.';
        } else {
          dialogText = 'Du har för många pågående transaktioner som ännu inte slutförts. Var god vänta och försök igen senare.';
        }
        break;
      case '6 297':
        dialogText = 'Du har pågående transaktioner som ännu inte slutförts. Var god vänta och försök igen senare.';
        break;
      case 3:
      case 408:
      case 666:
        isShowChangeDeposit = true; 
        dialogText = 'Fel vid insättning. Försök igen senare eller kontakta Svenska Spels Kundservice.';
        break;
      case 1033:
      case 100017:
        dialogText = 'Maxgränsen per insättning överskriden, sänk beloppet och försök igen.';
        break;
      case 1131:
        dialogText = 'Du har angett för lågt belopp, höj beloppet och försök igen.';
        break;
      case 63:
      case 50107:
        dialogTitle = 'Insättningen gick inte att genomföra';
        dialogText = maxLimitLeft ?
        dialogText = "<p>Du har ".concat(svs.utils.format.Currency(maxLimitLeft), " kr kvar till maxgr\xE4nsen den h\xE4r m\xE5naden. </p> \n        <p><a href=\"").concat(svs.core.urlMapping.get('myLimitsMax'), "\">L\xE4s mer om din maxgr\xE4ns</a> </p>") : "<p>Du har passerat din maxgr\xE4ns eller kommer g\xF6ra det med denna ins\xE4ttning.</p>\n        <p><a href=\"".concat(svs.core.urlMapping.get('myLimitsMax'), "\">L\xE4s mer om din maxgr\xE4ns</a> </p>");
        break;
      case 62:
      case 50105:
        dialogTitle = 'Insättningen gick inte att genomföra';
        dialogText = 'Du har ett pågående köp i butik.';
        break;
      case 100020:
        isShowKycError = true; 
        break;
      case 100031:
        dialogText = 'Du har inte satt någon insättningsgräns, sätt insättningsgräns och försök igen.';
        break;
      case 100032:
        dialogText = "Du har \xF6verskridit din ins\xE4ttningsgr\xE4ns. ".concat(depositLimitsCommonError);
        break;
      case 100033:
        dialogText = "Du har \xF6verskridit din dagliga ins\xE4ttningsgr\xE4ns. ".concat(depositLimitsCommonError);
        break;
      case 100034:
        dialogText = "Du har \xF6verskridit din ins\xE4ttningsgr\xE4ns f\xF6r veckan. ".concat(depositLimitsCommonError);
        break;
      case 100035:
        dialogText = "Du har \xF6verskridit din ins\xE4ttningsgr\xE4ns f\xF6r m\xE5naden. ".concat(depositLimitsCommonError);
        break;
      case 100037:
        break;
      case 100012:
        isShowChangeDeposit = true; 
        dialogText = 'Okänd insättningsmetod, välj en av bankerna vi stödjer och försök igen.';
        break;
      case 100016:
        dialogText = 'Det gick inte att tolka giltighetstiden, försök igen eller kontakta Svenska Spels Kundservice.';
        break;
      case 1000001:
        dialogText = 'Maxtiden för insättningen har överskridits.';
        break;
      case 100024: 
      case 100025:
        if (paymentTypeLower === paymentTypes.SWISH) {
          const _handleSwishSsnError = handleSwishSsnError(),
            swishMsg = _handleSwishSsnError.swishMsg,
            swishDialogTitle = _handleSwishSsnError.swishDialogTitle;
          dialogText = swishMsg;
          dialogTitle = swishDialogTitle;
        }
        break;
      case 100026:
        dialogTitle = 'Vi kunde inte genomföra insättningen';
        dialogText = 'Du har uppnått gränsen hos din bank för betalningar med Swish.';
        break;
      case 500001:
        dialogText = 'Din insättning misslyckades. Försök med en annan insättningsmetod eller försök igen senare. Om felet kvarstår kontakta Svenska Spels Kundservice.';
        logger.info("Swp script error for ".concat(paymentTypeLower, " deposit. Error: ").concat(errorCode), error);
        break;
      case 100036: 
      default:
        {
          isShowChangeDeposit = true;
          const codes = {
            10036: 'General client error'
          };
          const prefix = "".concat(codes[errorCode] || 'Unhandled error code');
          dialogText = 'Din insättning misslyckades försök igen senare eller kontakta Svenska Spels Kundservice.';
          logger.warn("".concat(prefix, " when trying to make ").concat(paymentTypeLower, " deposit: ").concat(errorCode), error);
        }
    }
  } else {
    logger.warn('Error trying to make transfer. Error object missing:', error);
  }
  return {
    dialogTitle,
    dialogText,
    showChangeDeposit: isShowChangeDeposit,
    showKycError: isShowKycError
  };
};

const showDepositError = (error, transactionData, maxLimitLeft) => {
  delete error.cellphone;
  delete error.accountBalance;
  const _getDepositErrorMessa = getDepositErrorMessage(error, transactionData, maxLimitLeft),
    dialogTitle = _getDepositErrorMessa.dialogTitle,
    dialogText = _getDepositErrorMessa.dialogText;
  const dialogConfirm = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    convertToPopup: false,
    autoClose: false,
    type: svs.ui.dialog.type.ERROR,
    title: dialogTitle,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: dialogText
    }],
    actions: [{
      type: svs.ui.dialog.button.SECONDARY,
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.close();
  svs.ui.dialog.api.add(dialogConfirm);
};

const showDepositSuccess = (successData, returnUrl) => new Promise(resolve => {
  var _returnUrl;
  const formatCurrency = svs.utils.format.Currency;
  const dialogObj = {
    dialogTitle: successData !== null && successData !== void 0 && successData.amount ? "Du har satt in ".concat(formatCurrency(successData.amount), " kr p\xE5 ditt spelkonto") : 'Insättning genomförd',
    dialogTextParagraph: successData !== null && successData !== void 0 && successData.accountBalance ? "Nytt saldo: ".concat(formatCurrency(successData.accountBalance), " kr.") : '',
    dialogTextAction: !returnUrl || ((_returnUrl = returnUrl) === null || _returnUrl === void 0 || (_returnUrl = _returnUrl.split('&')) === null || _returnUrl === void 0 ? void 0 : _returnUrl[0]) === svs.core.urlMapping.get('transactionsHome') ? 'Okej' : 'Tillbaka',
    dialogCallbackAction: resolve
  };

  returnUrl = (successData === null || successData === void 0 ? void 0 : successData.returnUrl) || returnUrl;
  if (returnUrl) {
    returnUrl = decodeURIComponent(returnUrl);
    dialogObj.dialogCallbackAction = () => {
      svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl));
      resolve();
    };
  }
  const showDialog = () => {
    const dialog = new svs.ui.dialog.Confirm({
      icon: 'thumbs-up',
      branding: svs.ui.dialog.branding.TUR,
      area: svs.ui.dialog.area.POPUP,
      title: dialogObj.dialogTitle,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: "".concat(dialogObj.dialogTextParagraph),
        align: svs.ui.dialog.message.align.CENTER
      }],
      actions: [{
        title: dialogObj.dialogTextAction,
        callback() {
          var _dialogObj$dialogCall;
          dialog.close();
          dialogObj === null || dialogObj === void 0 || (_dialogObj$dialogCall = dialogObj.dialogCallbackAction) === null || _dialogObj$dialogCall === void 0 || _dialogObj$dialogCall.call(dialogObj);
        }
      }]
    });
    svs.ui.dialog.api.close();
    svs.ui.dialog.api.add(dialog); 
  };
  showDialog();
});
svs.accountservicesReact.deposit.dialogs.sharedDialogs = {
  showDepositError,
  showDepositSuccess,
  getDepositErrorMessage
};

 })(window);